<template>
  <v-card class="d-flex align-start px-3 py-5 pa-sm-6 rounded-xl">
    <v-card-title class="pa-0">
      <v-btn
        color="#ffe2e2"
        :height="xsOnly ? 40 : 48"
        :width="xsOnly ? 40 : 48"
        depressed
        fab
      >
        <v-icon color="#e7000b" :size="xsOnly ? 20 : 24">
          mdi-alert-outline
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0 ml-3 ml-sm-4 mt-n1">
      <div class="black--text text-subtitle-1 text-sm-h6 font-weight-bold">
        {{ title }}
      </div>

      <div
        class="grey--text text--darken-2 text-body-2 text-sm-body-1 mt-1 delete-text"
      >
        <div v-html="parsedText"></div>
        <div v-if="changeText" v-html="changeText"></div>
      </div>

      <div class="d-flex justify-end mt-3 mt-sm-5">
        <v-btn
          @click.prevent="$emit('close')"
          class="rounded-lg"
          color="#dddddd"
          :disabled="loading"
          :small="xsOnly"
          outlined
          dense
        >
          <div class="black--text text-none">Cancelar</div>
        </v-btn>

        <v-btn
          @click.prevent="$emit('confirm')"
          class="rounded-lg ml-2"
          color="#e7000b"
          :loading="loading"
          :small="xsOnly"
          depressed
          dense
        >
          <div class="white--text text-none">{{ btnText }}</div>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Apagar",
    },
    name: {
      type: String,
      default: "esse item",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Tem certeza que deseja apagar",
    },
    changeText: {
      type: String,
      default: "Esta ação não pode ser desfeita.",
    },
    btnText: {
      type: String,
      default: "Apagar",
    },
  },
  computed: {
    parsedText() {
      return `${this.text} <b class="black--text">${this.name}</b>?`;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-text {
  line-height: 1.3 !important;

  div:first-child {
    margin-bottom: 2px;
  }
}
</style>
